import React from 'react';

import { AppRouter } from './router/AppRouter';

export const LooleeBear = () => {
  return (
      <AppRouter/>
  )
};
